// 参考: https://evoworx.dev/blog/5euh64nho0w/
class FormValidation {
  constructor(el, data) {
    this.dom = {el: el};

    // this.dom.backButton = document.querySelector('[data-action="back"]');
    // this.dom.backButton.type = 'button'

    this.dom.validated = this.dom.el.querySelectorAll('[data-validations]');
    [...this.dom.validated].forEach(el => {
      const validations = el.getAttribute('data-validations').split(' ');
      const hasRequired = validations.includes('required');
      const hasEmail = validations.includes('email');

      if (el.name === 'kana') {
        el.pattern = "^[ァ-ンー]*$";
      } else if (el.name === 'zip') {
        el.pattern = "^(\\d{3})-?(\\d{4})$";
      } else if (el.name === 'tel') {
        el.pattern = "^0\\d{9,10}$|^0\\d{1,4}-\\d{1,4}-\\d{4}$";
      } else if (el.name === 'age') {
        el.pattern = "\\d{1,2}$";
        // el.pattern = "^0\\d{9,10}$|^0\\d{1,4}-\\d{1,4}-\\d{4}$";
      } else if (hasEmail || el.name === 'email' || el.name === 'email-confirm') {
        el.pattern = "[A-Za-z0-9._+\\-']+@[A-Za-z0-9.\\-]+\\.[A-Za-z]{2,}$";
      }

      if (hasRequired) {
        if (el.classList.contains('smf-radio-buttons-control__control')) {
          const radios = el.querySelectorAll('input[type="radio"]');
          [...radios].forEach(radio => {
            radio.required = true;
          })
        } else if (el.classList.contains('smf-checkboxes-control__control')) {
          const checkboxes = el.querySelectorAll('input[type="checkbox"]');
          [...checkboxes].forEach(checkbox => {
            checkbox.required = true;
          })
        } else {
          el.required = true;
        }
      }

      const errorMessageBox = '<span class="error-message" aria-live="off" aria-hidden="true"></span>';
      el.closest('.smf-placeholder').insertAdjacentHTML('beforeend', errorMessageBox);
    });

    document.addEventListener('DOMContentLoaded', () => {
      this.init();
      this.confirmEvent();
      console.log('load')
    });
  }

  init() {
    const FORM_ELEMENT_CLASS = '[class*="-control__control"]'; // フォーム要素のクラス名
    const PARENT_CLASS = 'smf-placeholder'; // フォーム要素の親要素のクラス名
    const ERROR_MESSAGE_CLASS = 'error-message'; // エラーメッセージ要素のクラス名
    const ERROR_CLASS = 'is-error'; // エラー表示用のクラス名
    const REQUIRED_CLASS = 'is-required'; // 必須項目表示用のクラス名
    const validationEventTypes = ['blur', 'change', 'input']; // バリデーションを行うイベント
    
    // 実施するバリデーション
    const validationTypes = ['patternMismatch', 'rangeOverflow', 'rangeUnderflow', 'tooLong', 'tooShort', 'typeMismatch', 'valueMissing'];

    // 言語別エラーメッセージ
    const errorMessages = {
      ja: {
        valueMissing: {
          default: '必須項目です',
          company: '会社名を入力してください',
          department: '部署名を入力してください',
          kana: 'フリガナを入力してください',
          fullname: 'お名前を入力してください',
          email: 'メールアドレスを入力してください',
          'email-confirm': 'メールアドレス（確認）を入力してください',
          tel: 'お電話番号を入力してください',
          message: 'お問い合わせ内容を入力してください',
          'agree[]': '個人情報保護方針への同意が必要です',
        },
        patternMismatch: {
          tel: '電話番号の形式で入力してください',
          email: 'メールアドレスの形式で入力してください',
          'email-confirm': 'メールアドレスの形式で入力してください',
          kana: 'カタカナで入力してください',
        },
        typeMismatch: {
          email: 'メールアドレスの形式で入力してください',
          'email-confirm': 'メールアドレスの形式で入力してください',
        },
        emailMismatch: 'メールアドレスが一致しません',
      },
      en: {
        valueMissing: {
          default: 'This field is required',
          company: 'Please enter your company name',
          department: 'Please enter your department name',
          kana: 'Please enter your name in katakana',
          fullname: 'Please enter your name',
          email: 'Please enter your email address',
          'email-confirm': 'Please enter your email address (confirmation)',
          tel: 'Please enter your phone number',
          message: 'Please enter your inquiry details',
          'agree[]': 'You must agree to the privacy policy',
        },
        patternMismatch: {
          tel: 'Please enter a valid phone number',
          email: 'Please enter a valid email address',
          'email-confirm': 'Please enter a valid email address',
          kana: 'Please enter in katakana',
        },
        typeMismatch: {
          email: 'Please enter a valid email address',
          'email-confirm': 'Please enter a valid email address',
        },
        emailMismatch: 'Email addresses do not match',
      },
    };

    // HTMLのlang属性に基づいてメッセージを切り替え（デフォルトは日本語）
    const lang = document.documentElement.lang?.startsWith('en') ? 'en' : 'ja';
    const customErrorTexts = errorMessages[lang];

    // バリデーションのエラーテキストを取得する
    const getCustomErrorText = (validity, element) => {
      const fieldName = element.name;
      const fieldType = element.type;
      
      // 優先順位: valueMissing > patternMismatch > その他のHTML5バリデーション > customError
      if (validity.valueMissing) {
        // フィールド名に対応するメッセージがあればそれを使用、なければデフォルト
        return customErrorTexts.valueMissing[fieldName] || customErrorTexts.valueMissing.default;
      }
      if (validity.patternMismatch) {
        if (customErrorTexts.patternMismatch && customErrorTexts.patternMismatch[fieldName]) {
          return customErrorTexts.patternMismatch[fieldName];
        }
      }
      if (validity.typeMismatch) {
        if (customErrorTexts.typeMismatch && customErrorTexts.typeMismatch[fieldName]) {
          return customErrorTexts.typeMismatch[fieldName];
        }
      }
      // 他のHTML5バリデーションタイプ
      for (const key of validationTypes) {
        if (validity[key] && customErrorTexts[key] && typeof customErrorTexts[key] === 'string') {
          return customErrorTexts[key];
        }
      }
      // customError（一致エラー）
      if (validity.customError) {
        return customErrorTexts.emailMismatch;
      }
      return undefined; // デフォルトメッセージを使用させる場合
    };

    // エラー状態を追加する
    const addErrorState = (parentElement, errorMessageElement, errorMessage, formElement) => {
      parentElement.classList.add(ERROR_CLASS);
      errorMessageElement.textContent = errorMessage;
      errorMessageElement.setAttribute('aria-live', 'polite');
      errorMessageElement.setAttribute('aria-hidden', 'false');
      if (formElement.hasAttribute('aria-invalid')) {
        formElement.setAttribute('aria-invalid', 'true');
      }
    };

    // エラー状態を削除する
    const removeErrorState = (parentElement, errorMessageElement, formElement) => {
      parentElement.classList.remove(ERROR_CLASS);
      errorMessageElement.textContent = '';
      errorMessageElement.removeAttribute('aria-live');
      errorMessageElement.setAttribute('aria-hidden', 'true');
      if (formElement.hasAttribute('aria-invalid')) {
        formElement.setAttribute('aria-invalid', 'false');
      }
    };

    // バリデーションのエラー状態を更新する
    const updateErrorState = (element) => { // errorMessage引数を削除し、内部で決定
      const parentElement = element.closest(`.${PARENT_CLASS}`);
      const errorMessageElement = parentElement.querySelector(`.${ERROR_MESSAGE_CLASS}`);
      if (!parentElement || !errorMessageElement) return;

      const validity = element.validity;
      let showError = !element.checkValidity(); // checkValidity()で全てのバリデーション状態をチェック
      let errorMessage = getCustomErrorText(validity, element) || element.validationMessage;

      if (showError && errorMessage) {
        addErrorState(parentElement, errorMessageElement, errorMessage, element);
      } else {
        removeErrorState(parentElement, errorMessageElement, element);
      }
    };

    // バリデーションのハンドリング (updateErrorStateに統合される部分が多い)
    const handleErrorValidation = (element) => {
      // setCustomValidityの結果も含む、要素の現在のバリデーション状態に基づいてエラー表示を更新
      updateErrorState(element);
    };
    
    // イベントにエラーハンドリングを登録する
    const attachValidationHandlers = (element) => {
      validationEventTypes.forEach((eventType) => {
        element.addEventListener(eventType, (event) => {
          const target = event.target;
    
          // フォーム要素かどうか確認
          if (!(target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement || target instanceof HTMLSelectElement)) {
            return; // フォーム要素でない場合はスキップ
          }
    
          // 個別のバリデーションを処理
          handleUniqueValidation(target);
          handleErrorValidation(target);
    
          // メールアドレスフィールドの場合は、一致バリデーションも実行
          if (target.name === 'email' || target.name === 'email-confirm') {
            validateEmailMatch();
          }

          // ボタン状態を更新
          updateSubmitButtonState();
        });
      });
    };

    // チェックボックスのrequired属性を更新する
    const updateRequiredAttribute = (element) => {
      const checkboxes = document.querySelectorAll(`input[type="checkbox"][name="${element.name}"]`);
      const checked = [...checkboxes].some((checkbox) => checkbox.checked);
      const requiredValue = checked ? undefined : 'required';
    
      checkboxes.forEach((checkbox) => (checkbox.required = requiredValue));
    };

    // フォーム要素固有の変換などのハンドリング（バリデーションとは直接関係ない部分）
    const handleUniqueValidation = (element) => {
      const elementType = element.type;
      if (elementType === 'checkbox') {
        updateRequiredAttribute(element);
      }
      if (element.name === 'zip') {
        element.value = formatPostalCode(toHalfWidth(element.value))
      }
      // email と email-confirm のカスタムバリデーションはここから削除
      // validateEmailMatch はイベントリスナーで直接呼び出す
    };

    // email と email-confirm が一致するかを確認するカスタムバリデーション
    const validateEmailMatch = () => {
      const emailField = document.querySelector('[name="email"]');
      const emailConfirmField = document.querySelector('[name="email-confirm"]');
      
      if (!emailField || !emailConfirmField) return;

      const emailValue = emailField.value;
      const confirmValue = emailConfirmField.value;

      const emailIsFilled = emailValue.trim() !== '';
      const confirmIsFilled = confirmValue.trim() !== '';

      const emailMatch = (emailValue === confirmValue);
      const mismatchErrorMessage = customErrorTexts.emailMismatch;

      // 1. 両方が空の場合、一致エラーは発生させない
      if (!emailIsFilled && !confirmIsFilled) {
        emailConfirmField.setCustomValidity(""); // customErrorをリセット
        emailField.setCustomValidity(""); // customErrorをリセット
        // 他のエラー（必須など）はhandleErrorValidationが処理する
        return;
      }
      
      // 2. 両方が入力済みで、かつ一致しない場合
      if (emailIsFilled && confirmIsFilled && !emailMatch) {
        emailConfirmField.setCustomValidity(mismatchErrorMessage); // customErrorを設定
      }
      // 3. どちらかが空、または一致する場合
      else {
        emailConfirmField.setCustomValidity(""); // customErrorをリセット
      }

      // 重要: setCustomValidityの後に、両方のフィールドのHTML5バリデーションを再評価
      // これにより、カスタムエラー（一致エラー）とHTML5バリデーションエラーが適切に表示される
      handleErrorValidation(emailField); // emailFieldのバリデーション状態を更新
      handleErrorValidation(emailConfirmField); // emailConfirmFieldのバリデーション状態を更新
    };

    // 郵便番号にハイフンを付ける（ついている場合は何もしない）
    function formatPostalCode(postalCode) {
      return postalCode.replace(/^(\d{3})(\d{4})$/, "$1-$2");
    }

    // 全角英数字を半角に変換
    function toHalfWidth(str) {
      // 全角英数字を半角に変換
      str = str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
      return str;
    }

    // 必須項目があれば親要素にクラスを付与する
    const addRequiredClass = (element) => {
      const parentElement = element.closest(`.${PARENT_CLASS}`);
    
      if (element.required) {
        parentElement.classList.add(REQUIRED_CLASS);
      }
    };

    // 全フィールドのバリデーション状態に応じて送信ボタンの有効/無効を切り替える
    const updateSubmitButtonState = () => {
      const submitButton = document.querySelector('[data-action="confirm"]');
      if (!submitButton) return;

      // email一致チェックを先に実行（setCustomValidityを反映させるため）
      validateEmailMatch();

      const formElements = document.querySelectorAll(`${FORM_ELEMENT_CLASS}`);
      let allValid = true;

      formElements.forEach((element) => {
        if (!(element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement || element instanceof HTMLSelectElement)) {
          return;
        }
        if (!element.checkValidity()) {
          allValid = false;
        }
      });

      submitButton.disabled = !allValid;
    };

    const validateAll = () => {
      const formElements = document.querySelectorAll(`${FORM_ELEMENT_CLASS}`);
      let isValid = true;
    
      // メールアドレスの一致バリデーションを先に実行
      validateEmailMatch();
    
      formElements.forEach((element) => {
        // フォーム要素かどうか確認
        if (!(element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement || element instanceof HTMLSelectElement)) {
          return; // フォーム要素でない場合はスキップ
        }
    
        // 個別処理とHTML5バリデーションの再実行
        handleUniqueValidation(element);
        handleErrorValidation(element);
    
        // checkValidity() を使用してバリデーションを確認
        if (!element.checkValidity()) {
          isValid = false;
        }
      });
    
      return isValid;
    };

    (() => {
      const formElements = document.querySelectorAll(`${FORM_ELEMENT_CLASS}`);

      formElements?.forEach((element) => {
        attachValidationHandlers(element);
        addRequiredClass(element);
      });

      const submitButton = document.querySelector(':is([data-action="confirm"], [data-action="complete"])');
      // const submitButton = document.querySelector('[data-action="confirm"]');
      if (submitButton) {
        submitButton.disabled = true; // 初期状態で無効化
        submitButton.addEventListener('click', (event) => {
          event.preventDefault(); // フォーム送信を一時停止
          const allValid = validateAll();
          if (allValid) {
            // フォーム送信処理を追加
            const formElement = this.dom.el.querySelector('[data-screen="input"]'); // フォーム要素を取得
            formElement.submit(); // 送信を実行
          } else {
            const target = this.dom.el.querySelectorAll('.is-error');
            if (target.length > 0 && target[0].closest('.smf-item')) { // エラー要素が存在する場合のみスクロール
              target[0].closest('.smf-item').scrollIntoView({behavior:'smooth'});
            }
          }
        });
      }
    })();
  }

  confirmEvent() {
    document.addEventListener('DOMContentLoaded', () => {
      const targetNode = document.querySelector('.snow-monkey-form'); // 監視対象の親要素を指定
      if (!targetNode) return;
    
      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            // 確認画面のクラスや要素が挿入されたかを確認
            if (document.querySelector('[data-action="back"]')) {
              console.log('確認画面に遷移しました');
              // 必要な処理をここに追加
              customConfirmScreenScript();
            }
          }
        }
      });
    
      // 監視の設定
      observer.observe(targetNode, { childList: true, subtree: true });
    });
    
    // 確認画面で実行するスクリプト例
    function customConfirmScreenScript() {
      console.log('確認画面用スクリプトが実行されました');
      // 必要なスクリプトをここに記述
      const backButton = document.querySelector('[data-action="back"]');
      if (backButton) {
        backButton.addEventListener('click', () => {
          window.history.back();
          return false;
        })
      }
    }
  }
}

export default FormValidation;